import React from 'react';
import classnames from 'classnames';

const buildSteps = ({ event } = {}) => {
  const isGeneral = event?.participantType === 'general';
  return [
    {
      label: 'STEP 1',
      title: (
        <span>
          <span className="small bg-black text-white py-1 px-2 mr-2">
            STEP 1
          </span>
          <span>
            参加の申込
          </span>
        </span>
      ),
    },
    {
      label: 'STEP 2',
      title: (
        <span>
          <span className="small bg-black text-white py-1 px-2 mr-2">
            STEP 2
          </span>
          <span>
            {isGeneral ? '参加者情報' : '参加するお子様'}
          </span>
        </span>
      ),
    },
    {
      label: '確認',
      title: '申込内容の確認',
    },
    {
      label: '完了',
      title: '完了',
    },
  ];
};

export default function EntryflowSection(props) {
  const { activeIndex, event } = props;
  const steps = buildSteps({ event });
  const activeStep = steps[activeIndex];

  return (
    <section className="container-fluid bg-light-grey p-3">
      <h5 className="text-center font-weight-bold p-3">
        {activeStep.title}
      </h5>
      <div>
        <ul className="stepflow m-0">
          {
            steps.map((step, i) => {
              return (
                <li className={classnames({ completed: i < activeIndex, active: i === activeIndex, })}>
                  <span className="bubble" />
                  {step.label}
                </li>
              );
            })
          }
        </ul>
      </div>
    </section>
  )
};
